import { render } from "./LivingDetail.vue?vue&type=template&id=2c290e02&scoped=true"
import script from "./LivingDetail.vue?vue&type=script&lang=js"
export * from "./LivingDetail.vue?vue&type=script&lang=js"

import "./LivingDetail.vue?vue&type=style&index=0&id=2c290e02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c290e02"

export default script